import styled from "@emotion/styled";
import theme from "../../theme";
import Calendars from "../../components/calendars";
import PeriodForCalendar from "../../components/periodForCalendar";
import { Button } from "../../components/common/Button";
import { useWindowSize } from "@reactuses/core";
import { useEffect, useRef, useState } from "react";
import { Box, SelectChangeEvent } from "@mui/material";
import { TableTitle } from "../../components/mobileSize/TableTitle";
import { FileDownloadIcon } from "../../assets/icons/icons";
import { FileDownModal } from "./FileDownModal";
import userStorage from "../../utils/userStorage";
//import { CustomTooltip } from "../../components/common/CustomTooltip";
import { SelectBoxGroupId } from "../../components/SelectBoxGroupId";
import { getMobileOptions } from "../../utils/constants";
import SelectBox from "../../components/selectBox";
import { FetchParams } from "./stastics";
import { useI18n } from "../../locales";

const { sm, md, lg } = theme.screen;
// 파일 다운로드 기능을 사용할 수 있는 유저 조건
// const DOWNLOADABLE_GOV_IDS = ["00000", "47130"];
const DOWNLOADABLE_GOV_IDS = [""];

export interface SubHeaderProps {
  changeStartDate: (param: Date | null) => void;
  changeEndDate: (param: Date | null) => void;
  onClickBtn?: ({ mobFilter, groupId }: FetchParams) => void;
  fakeStartDate?: any;
  fakeEndDate?: any;
  width?: string;
  setStartDate?: any;
  setEndDate?: any;
  date?: string | null;
  isReportModal?: boolean;
  setIsNotInitialValue?: any; // 사용 리포트에 초기데이터 확인용
  dayDiffCheck?: (startDate: Date, endDate: Date) => boolean; // 날짜 차이 계산 오류시 true를 반환해야함
  isMobileSize?: boolean;
}

const SubHeader: React.FC<SubHeaderProps> = (props) => {
  const { t } = useI18n();
  const {
    setStartDate,
    setEndDate,
    fakeStartDate,
    fakeEndDate,
    changeStartDate,
    changeEndDate,
    onClickBtn,
    width,
    isReportModal,
    setIsNotInitialValue,
    dayDiffCheck,
    isMobileSize,
  } = props;
  const user = userStorage.get();
  const { width: windowWidth } = useWindowSize();
  const componentRef = useRef<HTMLDivElement>(null);
  const [mobileWidth, setMobileWidth] = useState(0);
  const [openFilter, setOpenFilter] = useState(false);
  const [openDownModal, setOpenDownModal] = useState(false);
  const isDownloadableUser = DOWNLOADABLE_GOV_IDS.some((el) =>
    user?.gov_id.includes(el)
  ); // 농콜 리포트 엑셀파일 다운로드 기능 사용 가능한지 여부
  const [groupSub, setGroupSub] = useState("all"); // 하위그룹코드(화면용)
  const [mobFilterOpen, setMobFilterOpen] = useState(false);
  const [mobFilter, setMobFilter] = useState(-1); // 화면용

  useEffect(() => {
    setMobileWidth(windowWidth / 2 - 40);
  }, [windowWidth]);

  const mobHandleChange = (event: SelectChangeEvent<typeof mobFilter>) => {
    setMobFilter(Number(event.target.value));
  };

  const mobHandleClose = () => {
    setMobFilterOpen(false);
  };

  const mobHandleOpen = () => {
    setMobFilterOpen(true);
  };

  const onSubmit = () => {
    if (onClickBtn) {
      onClickBtn({ mobFilter, groupId: groupSub });
    }
    if (dayDiffCheck) {
      // 두 날짜의 차이가 설정값보다 크면 에러
      let isError = dayDiffCheck(fakeStartDate, fakeEndDate);
      if (isError) {
        return;
      }
    }
    setStartDate(fakeStartDate);
    setEndDate(fakeEndDate);
    changeStartDate(fakeStartDate);
    changeEndDate(fakeEndDate);
  };

  if (isMobileSize) {
    return (
      <>
        {/* 필터 섹션 */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minHeight: openFilter ? "auto" : "0px",
            maxHeight: openFilter ? "100vh" : "0px",
            overflow: openFilter ? "visible" : "hidden",
            gap: "6px",
            paddingBottom: openFilter ? "16px" : "0px",
            position: "relative",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: `8px`,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <SelectBox
              open={mobFilterOpen}
              filter={mobFilter}
              handleChange={mobHandleChange}
              handleClose={mobHandleClose}
              handleOpen={mobHandleOpen}
              title={t.mobileList.selectDeviceType}
              menuItems={getMobileOptions(t)}
              width={140}
              mr="0px"
              srLabel={t.mobileList.selectDeviceType}
            />
            {/* 하위 그룹 조회 */}
            <SelectBoxGroupId
              groupSub={groupSub}
              setGroupSub={setGroupSub}
              width={140}
            />
          </Box>

          <Calendars
            startDate={fakeStartDate}
            endDate={fakeEndDate}
            setStartDate={changeStartDate}
            setEndDate={changeEndDate}
            isSeparate={false}
            width={140}
            justifyContent="center"
            gap="8px"
          ></Calendars>

          <MobileWrapper>
            <PeriodForCalendar
              startDate={fakeStartDate}
              endDate={fakeEndDate}
              setStartDate={changeStartDate}
              setEndDate={changeEndDate}
              width={"100%"}
              withoutTitle
            />

            <Button
              bgColor={theme.statusColor.MAIN}
              hoverColor={theme.statusColor.MAIN_HOVER}
              onClick={onSubmit}
              height="30px"
              width="100%"
            >
              {t.statistics.search}
            </Button>
          </MobileWrapper>

          {/* 파일 다운로드 버튼 */}
          {!isReportModal && (
            <FileDownloadButton onClick={() => setOpenDownModal(true)}>
              <FileDownloadIcon
                width="32px"
                height="32px"
                color={theme.color.green_500}
              />
            </FileDownloadButton>
          )}
          {openDownModal && (
            <FileDownModal
              open={openDownModal}
              onPressNo={() => setOpenDownModal(false)}
              startDate={fakeStartDate}
              endDate={fakeEndDate}
            />
          )}
        </Box>

        {/* 테이블 타이틀 섹션 */}
        <TableTitle
          title=""
          setOpenFilter={setOpenFilter}
          buttonsJustifyContent="end"
        />
      </>
    );
  }

  // 데스크탑 버전
  return (
    <Wrapper $width={width} $isReportModal={isReportModal}>
      <CalendarWrapper ref={componentRef} $isReportModal={isReportModal}>
        <Calendars
          startDate={fakeStartDate}
          endDate={fakeEndDate}
          setStartDate={changeStartDate}
          setEndDate={changeEndDate}
          isSeparate={
            isReportModal ? (windowWidth <= sm ? false : true) : false
          }
          width={windowWidth <= sm ? mobileWidth : undefined}
          gap={!isReportModal ? "20px" : undefined}
        />
      </CalendarWrapper>

      {/* 감지내역 통계용 */}
      {!isReportModal && (
        <>
          <div>
            <PeriodForCalendar
              startDate={fakeStartDate}
              endDate={fakeEndDate}
              setStartDate={changeStartDate}
              setEndDate={changeEndDate}
              width={windowWidth <= sm ? mobileWidth : undefined}
            />
          </div>
          <SelectBox
            open={mobFilterOpen}
            filter={mobFilter}
            handleChange={mobHandleChange}
            handleClose={mobHandleClose}
            handleOpen={mobHandleOpen}
            title={t.mobileList.selectDeviceType}
            menuItems={getMobileOptions(t)}
            width={160}
            mr="0px"
            srLabel={t.mobileList.selectDeviceType}
          />
          {/* 하위 그룹 조회 */}
          <SelectBoxGroupId
            groupSub={groupSub}
            setGroupSub={setGroupSub}
            width={160}
          />

          <Button
            bgColor={theme.statusColor.MAIN}
            hoverColor={theme.statusColor.MAIN_HOVER}
            onClick={onSubmit}
            height={windowWidth > md ? "40px" : undefined}
            width={windowWidth <= sm ? `${mobileWidth}px` : "85px"}
            style={{ marginTop: windowWidth > md ? "15px" : "19px" }}
          >
            {t.statistics.search}
          </Button>
        </>
      )}

      {/* 리포트 모달용 */}
      {isReportModal && (
        <PeriodButtonWrapper $isReportModal={isReportModal}>
          {
            <div>
              <PeriodForCalendar
                startDate={fakeStartDate}
                endDate={fakeEndDate}
                setStartDate={changeStartDate}
                setEndDate={changeEndDate}
                width={windowWidth <= sm ? mobileWidth : undefined}
              />
            </div>
          }
          <div>
            <Button
              bgColor={theme.statusColor.MAIN}
              hoverColor={theme.statusColor.MAIN_HOVER}
              onClick={() => {
                if (onClickBtn) {
                  onClickBtn({ mobFilter, groupId: groupSub });
                }
                if (dayDiffCheck) {
                  // 두 날짜의 차이가 설정값보다 크면 에러
                  let isError = dayDiffCheck(fakeStartDate, fakeEndDate);
                  if (isError) {
                    return;
                  }
                }
                setStartDate(fakeStartDate);
                setEndDate(fakeEndDate);
                changeStartDate(fakeStartDate);
                changeEndDate(fakeEndDate);
                if (isReportModal) {
                  setIsNotInitialValue(true);
                }
              }}
              height={windowWidth > md ? "40px" : undefined}
              width={windowWidth <= sm ? `${mobileWidth}px` : "85px"}
              style={{ marginTop: windowWidth > md ? "15px" : "19px" }}
            >
              {t.statistics.search}
            </Button>
          </div>
        </PeriodButtonWrapper>
      )}

      {/* 파일 다운로드 버튼 */}
      {!isReportModal && isDownloadableUser && (
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            marginTop: "15px",
          }}
        >
          <Button
            bgColor={theme.color.aquamarine_500}
            hoverColor={theme.color.aquamarine_600}
            onClick={() => setOpenDownModal(true)}
            height="40px"
          >
            <FileDownloadIcon
              width="32px"
              height="32px"
              color={theme.color.white}
            />
            {t.statistics.download}
          </Button>
        </div>
      )}

      {/* {!isReportModal && (
        <FileDownloadButton onClick={() => setOpenDownModal(true)}>
          <FileDownloadIcon
            width="32px"
            height="32px"
            color={theme.color.green_500}
          />
        </FileDownloadButton>
      )} */}
      {openDownModal && (
        <FileDownModal
          open={openDownModal}
          onPressNo={() => setOpenDownModal(false)}
          startDate={fakeStartDate}
          endDate={fakeEndDate}
        />
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div<{
  $width: string | undefined;
  $isReportModal?: boolean;
}>`
  width: ${({ $width }) => $width && $width};
  height: 92px;
  background: ${theme.color.neutral_50};
  box-shadow: ${({ $isReportModal }) =>
    !$isReportModal && `0px 4px 10px rgba(0, 0, 0, 0.25)`};
  border: ${({ $isReportModal }) =>
    $isReportModal && `3px solid ${theme.color.neutral_100}`};
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding-left: 30px;
  padding-right: 30px;
  margin-bottom: 23px;
  flex-wrap: wrap;
  gap: 20px;

  /* 리포트 모달 */
  @media (max-width: ${md}px) {
    padding-left: ${({ $isReportModal }) => $isReportModal && "0px"};
    padding-right: ${({ $isReportModal }) => $isReportModal && "px"};
  }

  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    padding-right: ${({ $isReportModal }) => $isReportModal && "30px"};
  }

  @media (max-width: ${lg}px) {
    min-height: ${({ $isReportModal }) => $isReportModal && "92px"};
    height: ${({ $isReportModal }) => $isReportModal && "auto"};
    padding-top: ${({ $isReportModal }) => $isReportModal && "10px"};
    padding-bottom: ${({ $isReportModal }) => $isReportModal && "10px"};
    flex-direction: ${({ $isReportModal }) =>
      $isReportModal ? "column" : "row"};
    gap: ${({ $isReportModal }) => $isReportModal && "10px"};
  }

  @media print {
    flex-direction: row;
    padding-left: 30px;

    button {
      height: 40px;
    }
  }
`;

const CalendarWrapper = styled.div<{ $isReportModal?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;

  /* @media (max-width: ${sm}px) {
    > div {
      flex-direction: ${({ $isReportModal }) =>
    $isReportModal ? "column" : "row"};
    }
  } */
`;

const PeriodButtonWrapper = styled.div<{ $isReportModal?: boolean }>`
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  gap: ${({ $isReportModal }) => ($isReportModal ? "40px" : "20px")};

  @media (max-width: ${sm}px) {
    gap: ${({ $isReportModal }) => $isReportModal && "15px"};
  }

  @media (max-width: ${lg}px) {
    margin-left: ${({ $isReportModal }) => $isReportModal && "0px"};
    margin-right: ${({ $isReportModal }) => $isReportModal && "0px"};
  }

  @media (min-width: ${sm + 1}px) and (max-width: ${lg}px) {
    button {
      width: ${({ $isReportModal }) =>
        $isReportModal ? "175px" : "56px"};
    }
  }
`;

const MobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;

  .MuiFormControl-root {
    width: 100%;
  }
`;

const FileDownloadButton = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  z-index: 2;
  margin-left: auto; /* 마지막 요소를 오른쪽으로 밀기 */
  margin-right: 20px;
  padding: 0;
  padding-top: 20px;
  &:hover {
    svg {
      fill: ${theme.color.green_600};
    }
  }

  @media (max-width: ${md}px) {
    position: absolute;
    top: 106%;
    padding: 0;

    svg {
      width: 24px;
      height: 24px;
    }
  }
`;

export default SubHeader;
